<template>
  <AppModal
    ref="modalRef"
    model-value
    body-class="col full-width"
    footer-class="q-pa-lg flex items-center border-top full-width"
    position="right"
    show-close-btn
    content-style="width: 420px;"
    :title="$t('label.takeBook')"
    @hide="$emit('hide')"
  >
    <q-form
      ref="emailFormRef"
    >
      <div
        v-if="book.coverImageUrl"
        class="book-cover full-width flex items-center justify-center"
      >
        <div class="cover">
          <img
            :src="book.coverImageUrl"
            class="border-radius-10"
          >
        </div>
      </div>
      <IntroBlock
        v-if="isSent"
        icon="far fa-circle-check"
        class="text-center q-mt-xl q-pa-lg intro-block"
        :title="$t('title.accessSentToEmail')"
      />
      <div
        v-else
        class="q-pa-lg"
      >
        <div class="text-weight-medium q-mb-lg fs-24">
          {{ book.metaFields.lockScreenTitleLink }}
        </div>
        <div class="q-mb-lg">
          {{ book.metaFields.lockScreenDescriptionLink }}
        </div>
        <AppInput
          v-model="email"
          :label="$t('text.yourEmail')"
          outlined
          :rules="[rules.REQUIRED, rules.EMAIL]"
          lazy-rules
        />
      </div>
    </q-form>

    <template
      v-if="!isSent"
      #footer
    >
      <AppButtonIcon
        :label="book.metaFields.lockScreenButtonText || $t('label.takeBook')"
        :icon="book.metaFields.lockScreenButtonIconLink"
        :icon-color="book.metaFields.lockScreenButtonColorIcon"
        :loading="isLoading"
        padding="12px"
        class="unlock-btn text-white border-radius-10 full-width"
        @click="isPreview ? $refs.modalRef.$refs.modalRef.hide() : onSubmit()"
      />
    </template>
  </AppModal>
</template>

<script setup>
import AppModal from 'components/AppModal.vue';
import AppInput from 'components/AppInput.vue';
import IntroBlock from 'components/IntroBlock.vue';
import handleError from 'src/helpers/handleError';
import { ref, inject } from 'vue';
import rules from 'src/helpers/rules';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import AppButtonIcon from 'components/AppButtonIcon.vue';

const bookPageStore = useBookPageStore();
const { book } = storeToRefs(bookPageStore);

const axios = inject('axios');

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const isLoading = ref(false);
const isSent = ref(false);
const email = ref(null);
const emailFormRef = ref(null);

async function onSubmit() {
  const isValid = await emailFormRef.value.validate();
  if (isValid) {
    isLoading.value = true;
    try {
      await axios.post(`public/books/${book.value.guid}/leads`, {
        email: email.value,
      });
      isSent.value = true;
    } catch (error) {
      handleError(error);
    } finally {
      isLoading.value = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.book-cover {
  height: 330px;
  background: linear-gradient(180deg, rgb(from var(--page-primary-color) r g b / 0) 0%, rgb(from var(--page-primary-color) r g b / 0.2) 100%);

  .cover {
    width: 170px;
    height: 240px;
    transform: rotate(7deg);
    border-radius: 10px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      box-shadow: 0.787px 0.787px 0.787px 0px rgba(0, 0, 0, 0.08);
    }
  }
}

.unlock-btn {
  background: var(--page-primary-color);
}

.intro-block {
  :deep(.q-icon) {
    color: var(--page-primary-color) !important;
  }
}
</style>
